import { Box } from "@mui/material";
import { useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { Document, pdfjs } from "react-pdf";

import { RootState } from "../../configureStore";
import YearPage from "../molecules/YearPage";

// Configure PDF.js worker

interface IssueCenterColumnParams {
}

const IssueCenterColumn = ({
}: IssueCenterColumnParams) => {
    const pdfUrl = useSelector<RootState, string | undefined>(({ bus }) => bus.yearPdf?.pdfUrl);
    const [retryRender, _setRetryRender] = useState<number>(0);
    const [rendered, setRendered] = useState<boolean>(false);

    // Memoize PDF options to prevent re-renders
    const pdfOptions = useMemo(() => ({
        wasmUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/wasm/`,
    }), []);

    return (
        <Box sx={[]}>
            <Document
                file={pdfUrl}
                renderMode="canvas"
                className="flex-center-center col"
                onError={(err) => {
                    console.error(err);
                }}
                options={pdfOptions}
            >
                <YearPage
                    rendered={rendered}
                    setRendered={setRendered}
                    retryRender={retryRender}
                />
            </Document>
        </Box>
    );
};

export default IssueCenterColumn;
